var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('files',{attrs:{"files":_vm.files,"title":_vm.title,"disabled":_vm.disabled,"is_uploading":_vm.is_uploading,"send_file_enabled":true,"show_description":true},on:{"add":_vm.addFile,"sendFile":_vm.sendFile}})}
var staticRenderFns = []

export { render, staticRenderFns }